import type { Locale } from '@brig/api-types';

/**
 * The colours a player can fly on the board, chosen apart from the nation: they mark the
 * cells of the player's ships, their ports and their Royal Port. Every colour is a clearly
 * different hue, so two fleets never look alike, and reads on the chart's paper.
 */
export interface PlayerColour {
  /** Stable id, stored with games and user preferences. */
  readonly id: string;
  readonly hex: string;
  readonly names: Readonly<Record<Locale, string>>;
}

export const PLAYER_COLOURS: readonly PlayerColour[] = [
  { id: 'red', hex: '#B42A23', names: { en: 'Red', uk: 'Червоний', ru: 'Красный' } },
  { id: 'blue', hex: '#2457A8', names: { en: 'Blue', uk: 'Синій', ru: 'Синий' } },
  { id: 'green', hex: '#2F7A35', names: { en: 'Green', uk: 'Зелений', ru: 'Зелёный' } },
  { id: 'amber', hex: '#C9861A', names: { en: 'Amber', uk: 'Бурштиновий', ru: 'Янтарный' } },
  { id: 'purple', hex: '#6E3A8E', names: { en: 'Purple', uk: 'Фіолетовий', ru: 'Фиолетовый' } },
  { id: 'teal', hex: '#17808A', names: { en: 'Teal', uk: 'Бірюзовий', ru: 'Бирюзовый' } },
];

export function isPlayerColour(id: unknown): id is string {
  return typeof id === 'string' && PLAYER_COLOURS.some((c) => c.id === id);
}

export function getPlayerColour(id: string): PlayerColour {
  const colour = PLAYER_COLOURS.find((c) => c.id === id);
  if (!colour) throw new Error(`Unknown player colour: ${id}`);
  return colour;
}
